export const MicrosoftIcon = (): JSX.Element => (
  <svg width='18' height='18' viewBox='0 0 18 18' xmlns='http://www.w3.org/2000/svg' aria-hidden='true'>
    <rect x='1' y='1' width='7.5' height='7.5' fill='#F25022' />
    <rect x='9.5' y='1' width='7.5' height='7.5' fill='#7FBA00' />
    <rect x='1' y='9.5' width='7.5' height='7.5' fill='#00A4EF' />
    <rect x='9.5' y='9.5' width='7.5' height='7.5' fill='#FFB900' />
  </svg>
)
